import React from 'react';

const PageContext = React.createContext();
PageContext.displayName = 'PageContext';

export default PageContext;
